// import { onEvent } from "./_dom";
import { ready } from "./ready";
import { modal } from "./_modal";
import { getRootUrl, getApiConfig } from "./context";
import { init as initErrorConsole } from "./errorConsole";

import { FS, init as initForms } from "./_fs.js";
import { TD } from "./_td.js";

import { Globalize } from "./_globalize";

import "./jsext";

import { initLoadDetails, initSearchAll } from "./dynload";
import { init as initTogglePickers } from "./togglePickers";
import { addInitControl } from "./dynrefresh";
import { ensureVisible } from "./_ensureVisible";
import { init as initCheckSearchValue } from "./_checkSearchValue";
import { init as initScrollOffsets } from "./_scroll";
import { init as initMenu } from "./_menu";
import * as AsyncViews from "./asyncViews";
import { init as initStickyCaptions } from "./_stickyCaption";
import { init as initV3Switch} from "./switch-v3";
import { init as initSidebar } from "./sidebar";
import { init as initMapViews } from "./mapView";
import { init as initStaticMapViews } from "./staticMap";
import { init as initStickyHeader } from "./stickyHeader";
import { init as initExpandSection } from "./expandSection";
import { initHeaderTabs, initActionsTabs } from "./tabs";
import { init as initToolbuttons } from "./actionButtons";
import { init as initFormSetup } from "./columnSettings";
import { init as initTooltips } from "./tooltip";
import { init as initDatePicker } from "./datepicker";
import { init as initDateRangePickers } from "./daterange";
import { init as initMultiselect } from "./multiselect";
import { init as initTimePicker, TimePicker } from "./timepicker";
import { init as initFilePicker } from "./filepicker";
import { init as initSignaturePicker } from "./signaturePicker";
import { init as initLocationField } from "./locationField";
import { init as initPatternField } from "./patternField";
import { init as initSelectCheckboxes } from "./selectCheckboxes";
import { init as initMarkupField } from "./markupField";
import { init as initAutocomplete } from "./typeinpicker";
import { init as initWorkspaceMenu } from "./workspace";
import "./dragAndDrop";
import { init as initClickToCopy } from "./clickToCopy";
import { init as initLinkPopup } from "./linkPopup";
import { openDocument } from "./docOpen";
import { init as initDocPrint } from "./docPrint";
import { init as initDocMulti } from "./docMulti";
import { init as initMultiRef } from "./multiref";
import { init as initCharts } from "./chartView";
import { init as initPrevNext } from "./prevNext";
import { init as initRowEdit } from "./rowEdit";
import { init as initRecordPicker } from "./recordpicker";
import { init as initAsyncAction } from "./asyncAction";
import { init as initChoices } from "./choices";
import { init as initSetValueFor } from "./setValueFor";
import { init as initCalendarViews } from "./calendarView";
import { init as initKanbanViews } from "./kanbanView";
import { init as initCustomize } from "./customizeCompat";
import { init as initHelpBox } from "./_helpbox";
import { /* init as initOpenAiGuide, */ initTipsButton } from "./openAIGuide";
import { init as initProfiler } from "./profiler";
import { init as initUserMenu } from "./userMenu";
import { init as initNumericFields } from "./numericField";
import { init as initAsyncDashboard } from "./asyncDashboard";
import { init as initColorPicker } from "./colorPicker";
import { init as initPreferencePicker, setPreferences } from "./colorTheme";
import { init as initAiViewChat } from "./openaichat";
import { init as initPasswordReveal } from "./passwordReveal";
import { init as initToggleVisiblity } from "./toggleVisibility";
import { init as initAnonymous } from "./anonymous";
import { init as initMyTeamDesk } from "./myteamdesk";
import { init as initKoForm, getModel as getKoModel } from "./knockout";
import { init as initTableFilters } from "./tableFilter";
import { loadCodeMirror6Async, initTextEditors } from "./texteditor";
import { init as initGraphViz } from "./graphviz";
import { init as initShowTarget } from "./showTarget";
import { init as initAutoComplete } from "./autocomplete";

// import { createBugReportButton } from "./bugreport";

// way too many scripts rely on window.gApiConfig
Object.defineProperty(window, 'gApiConfig', { get: () => JSON.parse(window.document.documentElement.dataset.apiConfig || "{}") });

setPreferences();

addInitControl(initDatePicker);
addInitControl(initTimePicker);
addInitControl(initFilePicker);
addInitControl(initLocationField);
addInitControl(initMarkupField);
addInitControl(initSignaturePicker);
addInitControl(initStaticMapViews);

AsyncViews.addCallback(initToolbuttons);
AsyncViews.addCallback(initStickyCaptions);
AsyncViews.addCallback(initCalendarViews);
AsyncViews.addCallback(initCharts);
AsyncViews.addCallback(initStaticMapViews);
AsyncViews.addCallback(initMapViews);
AsyncViews.addCallback(initKanbanViews);
AsyncViews.addCallback(initCustomize);

TD.TimePicker = TimePicker;

// init stuff immediately
(function init(context) {
	initSidebar(context);
	initV3Switch(context);
	initExpandSection(context);
	initDocPrint(context);
	initSelectCheckboxes(context);
	initMultiRef(context);
	initPrevNext(context);
	initTooltips(context);
	initTogglePickers(context);
	initWorkspaceMenu(context);
	initRowEdit(context);
	initRecordPicker(context);
	initChoices(context);
	initPatternField(context);
	initAutocomplete(context);
	initSetValueFor(context);
	initLinkPopup(context);
	initHelpBox(context);
	initNumericFields(context);

	// init stuff when loaded
	ready(() => {
		initCheckSearchValue(context);
		initTipsButton(context);
		// createBugReportButton();
		initForms(context);
		initStickyHeader(context);
		initHeaderTabs(context);
		initToolbuttons(context);
		initActionsTabs(context);
		initDatePicker(context);
		initTimePicker(context);
		initFilePicker(context);
		initSignaturePicker(context);
		// initPatternField(context);
		initLocationField(context);
		initMarkupField(context);
		// initAutocomplete(context);
		initDateRangePickers(context);
		initMultiselect(context);

		initMenu(context);  /// likely can rewrite via lazy init 

		initCalendarViews(context);
		initCharts(context);
		initMapViews(context);
		initKanbanViews(context);
		initCustomize(context);

		initLoadDetails(context);
		initSearchAll(context);
		initDocMulti(context);
		initAsyncAction(context);

		initStickyCaptions(context);

		initFormSetup(context);
		initScrollOffsets();

		initClickToCopy(context);
		initStaticMapViews(context);

		initPreferencePicker(context);

		initProfiler(context);
		initUserMenu(context);

		initErrorConsole(context);

		initAsyncDashboard(context);

		initColorPicker(context);
		initAiViewChat(context);
		initPasswordReveal(context);
		initToggleVisiblity(context);
		initKoForm(context);
		initTableFilters(context);
		initAnonymous(context);
		initMyTeamDesk(context);
		initTextEditors(context);

		initShowTarget(context);
		initGraphViz(context);
		initAutoComplete(context);

		openDocument(getApiConfig("opendoc"));
	});

	window.addEventListener("load", () => {
		// wait for images to load
		ensureVisible(location.hash);
		// initOpenAiGuide();
	});

})(document.documentElement);

import ko from "@tko/build.knockout";
import { dbfetch, nativeFetch } from "./dbfetch";

TD.getKoModel = getKoModel;
TD.loadCodeMirror6Async = loadCodeMirror6Async;

ko.ext ||= {};
ko.ext.onlyOneZipFile = function (files) {
	return files.length == 1 && /application\/(x-)?zip(-compressed)?/.test(files[0].type);
}


export { Globalize, FS, TD, ko, dbfetch, dbfetch as fetch, nativeFetch };
